// AddOnList.tsx
import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';

interface AddOnListProps {
  handleShowSelectNewAddon: () => void;
  accommodationAddOnItems: React.ReactNode;
  disabled?: boolean;
}

const AddOnList: React.FC<AddOnListProps> = ({
  handleShowSelectNewAddon,
  accommodationAddOnItems,
  disabled = false,
}) => {
  return (
    <>
      <div className="d-flex align-items-start mt-48 mb-24">
        <h2 className="h5 h-md-4 flex-grow-1 me-16">Lisäpalvelut</h2>
        <Button
          size="sm"
          disabled={disabled}
          onClick={handleShowSelectNewAddon}
        >
          <Icon Name="plus" CssClass="me-8" />
          Lisää uusi lisäpalvelu
        </Button>
      </div>
      <div className="table-responsive-lg mb-48">
        <Table>
          <thead>
            <tr key="AddOnsHeader1">
              <th>Lisäpalvelu</th>
              <th>Sisältyy hintaan</th>
              <th>Käytössa</th>
              <th>Myyntihinta</th>
              <th colSpan={3}>Ostohinta</th>
            </tr>
          </thead>
          <tbody>{accommodationAddOnItems}</tbody>
        </Table>
      </div>
    </>
  );
};

export default AddOnList;
